import axios from "../config/axiosConfig";

const login = (data) => {
  const headers = {
    // Accept: "*/*",
    // "access-control-allow-origin": "*",
    "Content-type": "multipart/form-data",
  };

  return new Promise(function (resolve, reject) {
    axios
      .post("/login", data, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const register = (data) => {
  const headers = {
    // Accept: "*/*",
    // "access-control-allow-origin": "*",
    "Content-type": "multipart/form-data",
  };

  return new Promise(function (resolve, reject) {
    axios
      .post("/register", data, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const verifyMobileByOTP = (data) => {
  const headers = {
    // Accept: "*/*",
    // "access-control-allow-origin": "*",
    "Content-type": "multipart/form-data",
  };

  return new Promise(function (resolve, reject) {
    axios
      .post("/send-otp", data, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const verifyMobileOTP = (data) => {
  const headers = {
    // Accept: "*/*",
    // "access-control-allow-origin": "*",
    "Content-type": "multipart/form-data",
  };

  return new Promise(function (resolve, reject) {
    axios
      .post("/verify-otp", data, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const forgotPassword = (data) => {
  const headers = {
    // Accept: "*/*",
    // "access-control-allow-origin": "*",
    "Content-type": "multipart/form-data",
  };

  return new Promise(function (resolve, reject) {
    axios
      .post("/forgot-password", data, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const changePassword = (data) => {
  let token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-type": "multipart/form-data",
    // Accept: "*/*",
    // "access-control-allow-origin": "*",
  };

  return new Promise(function (resolve, reject) {
    axios
      .post("/change-password", data, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        handleAuthFailure(error, reject);
      });
  });
};

const messageApi = (data) => {
  const headers = {
    "Content-type": "multipart/form-data",
  };

  return new Promise(function (resolve, reject) {
    axios
      .post("/contact-us", data, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const verifyToken = (data) => {
  let token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-type": "multipart/form-data",
    // Accept: "*/*",
    // "access-control-allow-origin": "*",
  };

  return new Promise(function (resolve, reject) {
    axios
      .post("/verify-token", data, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        handleAuthFailure(error, reject);
      });
  });
};

const resetPassword = (data) => {
  // let token = localStorage.getItem("token");

  const headers = {
    // Authorization: `Bearer ${token}`,
    "Content-type": "multipart/form-data",
    // Accept: "*/*",
    // "access-control-allow-origin": "*",
  };

  return new Promise(function (resolve, reject) {
    axios
      .post("/reset-password", data, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        handleAuthFailure(error, reject);
      });
  });
};

const addBussiness = (data) => {
  let token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-type": "multipart/form-data",
  };

  return new Promise(function (resolve, reject) {
    axios
      .post("/add-business", data, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        handleAuthFailure(error, reject);
      });
  });
};

const addToCart = (data) => {
  let token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-type": "multipart/form-data",
  };

  return new Promise(function (resolve, reject) {
    axios
      .post("/add-cart", data, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        handleAuthFailure(error, reject);
      });
  });
};

const addLottery = (data) => {
  let token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-type": "multipart/form-data",
  };

  return new Promise(function (resolve, reject) {
    axios
      .post("/add-lottery", data, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        handleAuthFailure(error, reject);
      });
  });
};





const updateCart = (data) => {
  let token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-type": "multipart/form-data",
  };

  return new Promise(function (resolve, reject) {
    axios
      .post("/update-qty", data, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        handleAuthFailure(error, reject);
      });
  });
};

const checkoutAPI = (data) => {
  let token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-type": "multipart/form-data",
  };

  return new Promise(function (resolve, reject) {
    axios
      .post("/checkout", data, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        handleAuthFailure(error, reject);
      });
  });
};

const addNewsLetter = (data) => {
  let token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-type": "multipart/form-data",
  };

  return new Promise(function (resolve, reject) {
    axios
      .post("/news-letter", data, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        handleAuthFailure(error, reject);
      });
  });
};

const updateBussiness = (data) => {
  let token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-type": "multipart/form-data",
  };

  return new Promise(function (resolve, reject) {
    axios
      .post("/update-business", data, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        handleAuthFailure(error, reject);
      });
  });
};

const updateMegaphone = (data) => {
  let token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-type": "multipart/form-data",
  };

  return new Promise(function (resolve, reject) {
    axios
      .post("/update-megaphone", data, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        handleAuthFailure(error, reject);
      });
  });
};

const updateProfile = (data) => {
  let token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-type": "multipart/form-data",
  };

  return new Promise(function (resolve, reject) {
    axios
      .post("/update-account", data, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        handleAuthFailure(error, reject);
      });
  });
};

const addClassifield = (data) => {
  let token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-type": "multipart/form-data",
  };

  return new Promise(function (resolve, reject) {
    axios
      .post("/add-classified", data, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        handleAuthFailure(error, reject);
      });
  });
};

const addMegaphone = (data) => {
  let token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-type": "multipart/form-data",
  };

  return new Promise(function (resolve, reject) {
    axios
      .post("/add-megaphone", data, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        handleAuthFailure(error, reject);
      });
  });
};

const updateClassifield = (data) => {
  let token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-type": "multipart/form-data",
  };

  return new Promise(function (resolve, reject) {
    axios
      .post("/update-classified", data, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        handleAuthFailure(error, reject);
      });
  });
};

const addJob = (data) => {
  let token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-type": "multipart/form-data",
  };

  return new Promise(function (resolve, reject) {
    axios
      .post("/add-job", data, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        handleAuthFailure(error, reject);
      });
  });
};

const addEvent = (data) => {
  let token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-type": "multipart/form-data",
  };

  return new Promise(function (resolve, reject) {
    axios
      .post("/add-event", data, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        handleAuthFailure(error, reject);
      });
  });
};

const paymentRenewBusinessApi = (data) => {
  let token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-type": "multipart/form-data",
  };

  return new Promise(function (resolve, reject) {
    axios
      .post("/paymentRenew-business", data, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        handleAuthFailure(error, reject);
      });
  });
};

const paymentRenewClassifiedApi = (data) => {
  let token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-type": "multipart/form-data",
  };

  return new Promise(function (resolve, reject) {
    axios
      .post("/paymentRenew-classified", data, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        handleAuthFailure(error, reject);
      });
  });
};

const paymentRenewMegaphoneApi = (data) => {
  let token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-type": "multipart/form-data",
  };

  return new Promise(function (resolve, reject) {
    axios
      .post("/paymentRenew-megaphone", data, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        handleAuthFailure(error, reject);
      });
  });
};

const paymentRenewEventApi = (data) => {
  let token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-type": "multipart/form-data",
  };

  return new Promise(function (resolve, reject) {
    axios
      .post("/paymentRenew-event", data, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        handleAuthFailure(error, reject);
      });
  });
};
const paymentRenewJobApi = (data) => {
  let token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-type": "multipart/form-data",
  };

  return new Promise(function (resolve, reject) {
    axios
      .post("/paymentRenew-job", data, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        handleAuthFailure(error, reject);
      });
  });
};
const updateEvent = (data) => {
  let token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-type": "multipart/form-data",
  };

  return new Promise(function (resolve, reject) {
    axios
      .post("/update-event", data, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        handleAuthFailure(error, reject);
      });
  });
};

const addDoctor = (data) => {
  let token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-type": "multipart/form-data",
  };

  return new Promise(function (resolve, reject) {
    axios
      .post("/add-doctor", data, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        handleAuthFailure(error, reject);
      });
  });
};

const updateJob = (data) => {
  let token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-type": "multipart/form-data",
  };

  return new Promise(function (resolve, reject) {
    axios
      .post("/update-job", data, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        handleAuthFailure(error, reject);
      });
  });
};
const getStateData = async () => {
  let token = await localStorage.getItem("token");
  let headers = {
    Authorization: `Bearer ${token}`,
  };
  return new Promise(function (resolve, reject) {
    axios
      .get(`/state`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        // handleAuthFailure(error, reject);
      });
  });
};

const getAccountData = async () => {
  let token = await localStorage.getItem("token");
  let headers = {
    Authorization: `Bearer ${token}`,
    //  Accept: "application/json",
    // Accept: "*/*",
    // "access-control-allow-origin": "*",
  };

  return new Promise(function (resolve, reject) {
    axios
      .get(`/my-account`, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getSubscriptionData = async () => {
  let token = await localStorage.getItem("token");
  let headers = {
    Authorization: `Bearer ${token}`,
  };

  return new Promise(function (resolve, reject) {
    axios
      .get(`/payment-detail`, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getCartData = async (page = 1, perPage = 10) => {
  let token = await localStorage.getItem("token");
  let headers = {
    Authorization: `Bearer ${token}`,
  };
  return new Promise(function (resolve, reject) {
    axios
      .get(`/view-cart`, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        // handleAuthFailure(error, reject);
      });
  });
};


const getWalletData = async (page = 1, perPage = 10) => {
  let token = await localStorage.getItem("token");
  let headers = {
    Authorization: `Bearer ${token}`,
  };
  return new Promise(function (resolve, reject) {
    axios
      .get(`/my-wallet?page=${page}`, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        // handleAuthFailure(error, reject);
      });
  });
};

const clearCartAPI = async (page = 1, perPage = 10) => {
  let token = await localStorage.getItem("token");
  let headers = {
    Authorization: `Bearer ${token}`,
  };
  return new Promise(function (resolve, reject) {
    axios
      .get(`/clear-cart`, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        // handleAuthFailure(error, reject);
      });
  });
};

const subscriptionPayment = (data) => {
  let token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-type": "multipart/form-data",
  };

  return new Promise(function (resolve, reject) {
    axios
      .post("/payment", data, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        handleAuthFailure(error, reject);
      });
  });
};




const addWallet = (data) => {
  let token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-type": "multipart/form-data",
  };

  return new Promise(function (resolve, reject) {
    axios
      .post("/add-wallet", data, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        handleAuthFailure(error, reject);
      });
  });
};


const getClassifieldPaymentSuccess = async (status) => {
  let token = await localStorage.getItem("token");
  let headers = {
    Authorization: `Bearer ${token}`,
  };

  return new Promise(function (resolve, reject) {
    axios
      .get(`/classified-payment-update?status=${status}`, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getEventPaymentSuccess = async (status) => {
  let token = await localStorage.getItem("token");
  let headers = {
    Authorization: `Bearer ${token}`,
  };

  return new Promise(function (resolve, reject) {
    axios
      .get(`/event-payment-update?status=${status}`, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getBussinessPaymentSuccess = async (status) => {
  let token = await localStorage.getItem("token");
  let headers = {
    Authorization: `Bearer ${token}`,
  };

  return new Promise(function (resolve, reject) {
    axios
      .get(`/business-payment-update?status=${status}`, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getDoctorPaymentSuccess = async (status) => {
  let token = await localStorage.getItem("token");
  let headers = {
    Authorization: `Bearer ${token}`,
  };

  return new Promise(function (resolve, reject) {
    axios
      .get(`/doctor-payment-update?status=${status}`, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getMegaphonePaymentSuccess = async (status) => {
  let token = await localStorage.getItem("token");
  let headers = {
    Authorization: `Bearer ${token}`,
  };

  return new Promise(function (resolve, reject) {
    axios
      .get(`/megaphone-payment-update?status=${status}`, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getJobPaymentSuccess = async (status) => {
  let token = await localStorage.getItem("token");
  let headers = {
    Authorization: `Bearer ${token}`,
  };

  return new Promise(function (resolve, reject) {
    axios
      .get(`/job-payment-update?status=${status}`, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const renewAPIforEvent = async (status) => {
  let token = await localStorage.getItem("token");
  let headers = {
    Authorization: `Bearer ${token}`,
  };

  return new Promise(function (resolve, reject) {
    axios
      .get(`/paymentRenew-update-event?status=${status}`, {
        headers: headers,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const renewAPIforMegaphone = async (status) => {
  let token = await localStorage.getItem("token");
  let headers = {
    Authorization: `Bearer ${token}`,
  };

  return new Promise(function (resolve, reject) {
    axios
      .get(`/paymentRenew-update-megaphone?status=${status}`, {
        headers: headers,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const renewAPIforJob = async (status) => {
  let token = await localStorage.getItem("token");
  let headers = {
    Authorization: `Bearer ${token}`,
  };

  return new Promise(function (resolve, reject) {
    axios
      .get(`/paymentRenew-update-job?status=${status}`, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const renewAPIforBussiness = async (status) => {
  let token = await localStorage.getItem("token");
  let headers = {
    Authorization: `Bearer ${token}`,
  };

  return new Promise(function (resolve, reject) {
    axios
      .get(`/paymentRenew-update-business?status=${status}`, {
        headers: headers,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const renewAPIforClassified = async (status) => {
  let token = await localStorage.getItem("token");
  let headers = {
    Authorization: `Bearer ${token}`,
  };

  return new Promise(function (resolve, reject) {
    axios
      .get(`/paymentRenew-update-classified?status=${status}`, {
        headers: headers,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getCityData = async (code) => {
  let token = await localStorage.getItem("token");
  let headers = {
    Authorization: `Bearer ${token}`,
  };
  return new Promise(function (resolve, reject) {
    axios
      .get(`/city?code=${code}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const logoutApi = async () => {
  let token = await localStorage.getItem("token");
  let headers = {
    Authorization: `Bearer ${token}`,
  };
  return new Promise(function (resolve, reject) {
    axios
      .get(`/logout`, { headers: headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        // handleAuthFailure(error, reject);
      });
  });
};

function handleAuthFailure(error, reject) {
  if (
    error?.response.status === 401 &&
    error?.response.data.message === "Unauthenticated."
  ) {
    localStorage.removeItem("token");
    localStorage.removeItem("is_authenticated");

    if (window.location.pathname != "/login") {
      window.location.href = "/#/login";
    }
  } else {
    reject(error);
  }
}

export {
  login,
  getAccountData,
  addBussiness,
  updateBussiness,
  logoutApi,
  subscriptionPayment,
  updateEvent,
  forgotPassword,
  addClassifield,
  addJob,
  getDoctorPaymentSuccess,
  getWalletData,
  getMegaphonePaymentSuccess,
  getJobPaymentSuccess,
  updateProfile,
  addToCart,
  getCartData,
  resetPassword,
  addMegaphone,
  paymentRenewMegaphoneApi,
  addWallet,
  addLottery,
  checkoutAPI,
  getSubscriptionData,
  messageApi,
  getEventPaymentSuccess,
  clearCartAPI,
  addNewsLetter,
  verifyToken,
  renewAPIforMegaphone,
  verifyMobileByOTP,
  paymentRenewBusinessApi,
  verifyMobileOTP,
  updateClassifield,
  addEvent,
  getClassifieldPaymentSuccess,
  updateMegaphone,
  paymentRenewClassifiedApi,
  changePassword,
  getBussinessPaymentSuccess,
  paymentRenewJobApi,
  paymentRenewEventApi,
  updateCart,
  renewAPIforClassified,
  renewAPIforBussiness,
  renewAPIforJob,
  renewAPIforEvent,
  updateJob,
  register,
  getCityData,
  getStateData,
  addDoctor,
};
